import React from "react";
import { MenuButton as ChakraMenuButton } from "@chakra-ui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Button } from "./button";
export function MenuButton(props) {
    return (React.createElement(ChakraMenuButton, { as: Button, directionIcon: ChevronDownIcon, ...props }));
}
